import useUser from '@vl-core/hooks/useUser';

export function useIsReferrerAdmin() {
  const user = useUser();
  const userRole = user?.user_type_code;

  return userRole === 'ADMIN';
}

export default useIsReferrerAdmin;
